import * as React from 'react'
import './Adminbookings.css'
import './AdminHome.css'

import { Button } from '../../Components/Button';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../Components/Card';
import { format, addDays, startOfWeek, endOfWeek, isSameDay, addWeeks, getISOWeek } from "date-fns";
import { sv } from "date-fns/locale";
import { AdminIcon } from '../../Icons/AdminIcon';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '../../Components/Table';
import { Modal } from '../../Components/Modal';
import { EmailFormsAdminBookings } from './EmailFormsAdminBookings';
import { Icon } from '../../Icons/Icon';
import { DataService } from '../../DataService/DataService';
import { BookingDto, BookingStatus } from '../../Types/BookingServiceTypes';
import Loader from '../../Components/Loader';
import { GlobalObjectMapping } from '../../Utils/GlobalObjectMapping';
import { toast } from 'react-toastify';
import { AddTimeSlotsModal } from './AdminBookingComps/AddTimeSlotsModal';
import { RemoveTimeSlotsConfirmationModal } from './AdminBookingComps/RemoveTimeSlotsConfirmationModal';
import { BookingNotesModal } from './AdminBookingComps/BookingNotesModal';
import { SendMailModal } from './AdminBookingComps/SendMailModal';
import { RescheduleModal } from './AdminBookingComps/RescheduleMoadl';
import { Link } from 'react-router-dom';
import { RebookRequestDto } from '../../Types/BookingServiceTypes';
// type BookingStatus = "confirmed" | "pending" | "material_sent" | "rescheduled" | "cancelled";

type Booking = {
  id: number;
  date: string;
  time: string;
  client: string;
  email: string;
  coach: string;
  type: string;
  status: BookingStatus;
  notes?: string;
  material_sent?: boolean;
};

export type AdminTimeSlot = {
  id: number;
  date: string;
  time: string;
  category: string;
  available: boolean;
  newTimeSlot:boolean;
};
type WeekResult = {
  weekNumber: number;
  weekStart: Date;
  weekEnd: Date;
  bookings: BookingDto[];
  weekStartLabel: string;
  weekEndLabel: string;
};

export const AdminBookings = () =>{
  //const fileUploadRef = React.useRef<HTMLInputElement>(null);
 
  const [weekOffset, setWeekOffset] = React.useState(0);
  const [emailFileAttachments,setEmailFileAttachments] = React.useState<DataTransfer>();
  const [bookings, setBookings] = React.useState<BookingDto[]/*Booking[]*/>(/*initialBookings*/[]);
  const [rebookRequests, setRebookRequests] = React.useState<RebookRequestDto[]>([]);
  const [timeSlots, setTimeSlots] = React.useState<AdminTimeSlot[]>([]);
  const [selectedDate, setSelectedDate] = React.useState<Date | undefined>(new Date());
  const [newTimeSlot, setNewTimeSlot] = React.useState("");
  const [selectedCategory, setSelectedCategory] = React.useState("public");
  const [isLoading,setIsLoading] = React.useState<boolean>(false);
  //const [showAddSlots, setShowAddSlots] = React.useState(true);
  const [showMaterialForm, setShowMaterialForm] = React.useState(false);
  const [selectedBooking, setSelectedBooking] = React.useState<BookingDto | null>(null);
  const [isSavingNewSlots,setIsSavingNewSlots] = React.useState<boolean>(false);
  const [materialSubject, setMaterialSubject] = React.useState("");
  const [materialContent, setMaterialContent] = React.useState("");
  const [selectedTimeSlot,setSelectedTimeSlot] = React.useState<AdminTimeSlot|undefined>(undefined);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState("");
  const [showModal,setShowModal] = React.useState<{'put-notes':boolean,'remove-timeslots':boolean,'submit-new-timeslots':boolean,'delete':boolean,'reschedule':boolean,'send_material':boolean}>({
    'put-notes':false,
    'remove-timeslots':false,
    "submit-new-timeslots":false,
    delete:false,
    reschedule:false,
    send_material:false
  });

  const reloadAdminData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const [bookedSlots, availableSlots, requests] = await Promise.all([
        DataService.BookingService.GetBookedSlots(),
        DataService.BookingService.GetAvailableTimeSlots(),
        DataService.BookingService.GetRebookRequests()
      ]);

      if (bookedSlots) {
        setBookings(bookedSlots);
      }

      if (availableSlots) {
        const timeSlotRows = availableSlots.map(x => ({
          id: x.id,
          date: x.date.getDateOnly(),
          time: x.startTime.getTime(),
          category: x.category ?? 'public',
          available: true,
          newTimeSlot: false
        }));

        setTimeSlots(timeSlotRows);
      }

      if (requests) {
        setRebookRequests(requests);
      }
    } catch (err) {
      console.log('Error fetching admin data', err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Get current week's bookings
  React.useEffect(() => {
    void reloadAdminData();
    toast.success("Hämtat in data.");
  },[reloadAdminData])
  const handleAvailabletimeSlotSubmit = async():Promise<void> => {
      setIsSavingNewSlots(true);
      const filterdSlots = timeSlots.filter(x => x.newTimeSlot);

      if (filterdSlots.length === 0) {
        toast.warning("Lägg till minst en ny tid innan du sparar.");
        setIsSavingNewSlots(false);
        return;
      }
       
      await DataService.BookingService.CreateAvailableTimeSlots(filterdSlots);
      setIsSavingNewSlots(false);
      handleModal('submit-new-timeslots');
  }
  const currentWeekBookings = React.useMemo(() =>{
         const now = new Date();
  const target = addWeeks(now, weekOffset);

  const weekStart = startOfWeek(target, { weekStartsOn: 1 });
  const weekEnd = endOfWeek(target, { weekStartsOn: 1 });
  const weekNumber = getISOWeek(target);

  // Filtrera
  const filtered = bookings.filter(b => {
    const bookingDate = new Date(b.slot.date.getDateOnly());
    return bookingDate >= weekStart && bookingDate <= weekEnd;
  });

  // Snygga etiketter för UI (ex: "11 nov")
  const weekStartLabel = format(weekStart, "d MMM", { locale: sv });
  const weekEndLabel = format(weekEnd, "d MMM", { locale: sv });

  return {
    weekNumber,
    weekStart,
    weekEnd,
    bookings: filtered,
    weekStartLabel,
    weekEndLabel
  };
  },[weekOffset,bookings]) 
    // const now = new Date();
    // const start = startOfWeek(now, { weekStartsOn: 1 });
    // const end = endOfWeek(now, { weekStartsOn: 1 });
    // const filterd = bookings.filter(booking => {
    //   const bookingDate = new Date(booking.slot.date.getDateOnly());
    //   return bookingDate >= start && bookingDate <= end;
    // });
    // return filterd
    
  

  const getStatusColor = (status: BookingStatus):React.CSSProperties => {
    switch (status) {
      case BookingStatus.Confirmed: return {backgroundColor:'hsl(var(--secondary) / 0.14)',color:'hsl(var(--secondary))'};
      case BookingStatus.Pending: return {backgroundColor:'hsl(var(--accent) / 0.14)',color:'hsl(var(--accent))'};
      case BookingStatus.Material_Sent: return {backgroundColor:'hsl(var(--primary) / 0.14)',color:'hsl(var(--primary))'};
      case BookingStatus.Rescheduled: return {backgroundColor:'hsl(var(--muted) / 0.75)',color:'hsl(var(--foreground))'};
      case BookingStatus.Cancelled: return {backgroundColor:'hsl(var(--destructive) / 0.12)',color:'hsl(var(--destructive))'};
      // default: return "bg-gray-100 text-gray-800";
    }
  };

  const getStatusText = (status: BookingStatus) => {
    switch (status) {
      case BookingStatus.Confirmed: return "Bekräftad";
      case BookingStatus.Pending: return "Väntar";
      case BookingStatus.Material_Sent: return "Material skickat";
      case BookingStatus.Rescheduled: return "Ombokning";
      case BookingStatus.Cancelled: return "Avbokad";
      default: return "Okänd";
    }
  };

  const getRebookStatusText = (status: string) => {
    switch (status) {
      case 'Pending': return 'Väntar';
      case 'Countered': return 'Motförslag';
      case 'Accepted': return 'Accepterad';
      case 'Declined': return 'Nekad';
      default: return status;
    }
  };

  const getRebookStatusColor = (status: string): React.CSSProperties => {
    switch (status) {
      case 'Pending': return { backgroundColor: 'hsl(var(--accent) / 0.14)', color: 'hsl(var(--accent))' };
      case 'Countered': return { backgroundColor: 'hsl(var(--primary) / 0.14)', color: 'hsl(var(--primary))' };
      case 'Accepted': return { backgroundColor: 'hsl(var(--secondary) / 0.14)', color: 'hsl(var(--secondary))' };
      case 'Declined': return { backgroundColor: 'hsl(var(--destructive) / 0.12)', color: 'hsl(var(--destructive))' };
      default: return { backgroundColor: 'hsl(var(--muted) / 0.75)', color: 'hsl(var(--foreground))' };
    }
  };

  const getCategoryText = (category?: string) => {
    switch (category) {
      case 'rot': return 'ROT';
      case 'grow': return 'GROW';
      case '__system-rot': return 'ROT';
      default: return 'Publik';
    }
  };

  const isRebookRequestActive = (request: RebookRequestDto) => {
    const expired = new Date(request.expiresAt).getTime() <= Date.now();
    return !request.isClosed && !expired && (request.status === 'Pending' || request.status === 'Countered');
  };

  const getRebookRequestStateText = (request: RebookRequestDto) => {
    if (request.isClosed) {
      return getRebookStatusText(request.status);
    }

    if (new Date(request.expiresAt).getTime() <= Date.now()) {
      return 'Utgången';
    }

    return getRebookStatusText(request.status);
  };

  const addTimeSlots = () => {
    if (selectedDate && newTimeSlot) {
      const nextId = timeSlots.length > 0
        ? Math.max(...timeSlots.map((slot) => slot.id)) + 1
        : 1;

      const newSlot: AdminTimeSlot = {
        id: nextId,
        date: format(selectedDate, "yyyy-MM-dd"),
        time: newTimeSlot,
        category: selectedCategory,
        available: true,
        newTimeSlot:true
      };
      setTimeSlots([...timeSlots, newSlot]);
      setNewTimeSlot("");
      showSuccessMessage("Ledig tid har lagts till");
    }
  };
  const handlePutNotes = async(id:number,currentNotes:string):Promise<void> => {
    setIsSavingNewSlots(true);
    const dbNotes = bookings.findIndex(x => x.id == id);
    if(dbNotes > -1){
      const result =  await DataService.BookingService.PutNote(id,currentNotes);
      if(result)
      setBookings(prev =>
                    prev.map(b =>
                    b.id === id
                    ? { ...b, notes: currentNotes }
                    : b
                  ));
    }
    handleModal('put-notes');
    setIsSavingNewSlots(false);
  }
  const removeTimeSlot = async(slotId: number):Promise<void> => {
    setIsSavingNewSlots(true);
    const dbTime = timeSlots.findIndex(x => x.id == slotId);
    console.log(slotId,dbTime)
    if(dbTime > -1){
        if(!timeSlots[dbTime].newTimeSlot){
           const res = await DataService.BookingService.DeleteSelectedTimeSlot(slotId);
           if(res){
            setTimeSlots(timeSlots.filter(slot => slot.id !== slotId));
           }
        }else{
          //lokalt state spelar ingen roll ta bort bara,det är en pågående session inget objekt som lever i databasen
          setTimeSlots(timeSlots.filter(slot => slot.id !== slotId));
          toast.success('Bortagning av tid fullföljd.');
        }
    handleModal('remove-timeslots');

    }else{
      toast.warning("Kunde inte hitta vald tid för borttagning.");
    }
    setIsSavingNewSlots(false);
  };

  const updateBookingStatus = (bookingId: number, newStatus: BookingStatus) => {
    setBookings(bookings.map(booking => 
      booking.id === bookingId 
        ? { ...booking, status: newStatus }
        : booking
    ));
    showSuccessMessage("Bokningsstatus uppdaterad");
  };

  const sendMaterial = () => {
    if (selectedBooking) {
      setBookings(bookings.map(booking => 
        booking.id === selectedBooking.id 
          ? { ...booking, status: BookingStatus.Material_Sent, material_sent: true }
          : booking
      ));
      setShowMaterialForm(false);
      setSelectedBooking(null);
      setMaterialSubject("");
      setMaterialContent("");
      showSuccessMessage("Förberedelsematerial skickat");
    }
  };
  /*
  Detta är två stycken events som ska ha en varsin modal för att fylla i ett mail som ska gå ut till den som har bokat
  */
 const handleModal = (key:'delete'|'reschedule'|'send_material'|'submit-new-timeslots'|'remove-timeslots'|'put-notes') => {
      const currState = structuredClone(showModal);
      // currState[key] = !currState[key];
      Object.entries(currState).forEach(entry => {
        if(entry[0] === key){
          currState[key] = !currState[key];
        }else{
          entry[1] = false;
        }
      });
      setShowModal(currState);
 }
  const rescheduleBooking = (bookingId: number) => {
    updateBookingStatus(bookingId, BookingStatus.Rescheduled);
  };

  const cancelBooking = (bookingId: number) => {
    updateBookingStatus(bookingId, BookingStatus.Cancelled);
  };

  const showSuccessMessage = (message: string) => {
    setSuccessMessage(message);
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  const formatDateKey = (date: Date) => format(date, "yyyy-MM-dd");
  const selectedDateKey = selectedDate ? formatDateKey(selectedDate) : "";
  const selectedDateSlots = timeSlots.filter(slot => slot.date === selectedDateKey);
//   const handleEmailFileAttachemnts = (fileList: FileList | null) => {
//     if (fileList) {
//       const dataTransfer = new DataTransfer();
//       Array.from(fileList).forEach((file) => dataTransfer.items.add(file));
//       setEmailFileAttachments(dataTransfer);
//     }
//   }
//   const removeFileAttachment = (fileName:string) =>{
//      if (!emailFileAttachments) return;

//   const newDataTransfer = new DataTransfer();

//   Array.from(emailFileAttachments.files)
//     .filter(file => file.name !== fileName)
//     .forEach(file => newDataTransfer.items.add(file));
//     setEmailFileAttachments(newDataTransfer);
//   }
//   function truncateFilename(filename:string, maxLength = 30) {
//   if (filename.length <= maxLength) return filename;
//   const start = filename.slice(0, 15);
//   const end = filename.slice(-10);
//   return `${start}...${end}`;
// }
   // const currentWeekBookings =  getCurrentWeekBookings();
  return (
    <div className="admin-page-shell admin-bookings-shell">
      <div className="admin-bookings-container-wrapper">
        {/* <Link to="/admin-home" className="admin-courses-home-link">
          
            <Icon.ArrowLeft width={16} height={16} fill='black'/> 
            Tillbaka till Admin Panel
          </Link> */}
        {/* Header */}
        <div className="admin-page-header admin-bookings-header" style={{textAlign:'start'}}>
           
          <h1 className="admin-page-title admin-bookings-header-text">Bokningshantering</h1>
          <p className="admin-page-subtitle admin-bookings-header-paragraph">Administrera 1:1-samtal och ledigatider</p>
        </div>

        {/* Success Alert */}
        {/* {showSuccess && (
          <Alert className="bg-white/95 backdrop-blur-sm border-0 shadow-xl">
            <CheckCircle className="h-4 w-4 text-[#E16A54]" />
            <AlertDescription className="text-[#7C444F] font-medium">
              {successMessage}
            </AlertDescription>
          </Alert>
        )} */}

        <div className="admin-bookings-grid">
          
          {/* Veckans bokningar */}
          {isLoading ? (<Loader loaderSize='XLARGE'/>):(
            <Card className="admin-surface-card admin-bookings-weeklyscheduled-card" disableHover>
            <CardHeader>
              <CardTitle className="admin-bookings-weeklyscheduled-card-title">
                
                <AdminIcon.SimpleCalendar  fill='hsl(var(--primary))'/>
                <div className='admin-bookings-arrow' style={{display:'flex',alignItems:'flex-end'}}>
                  <Icon.ArrowLeft className='left' fill='hsl(var(--foreground))' width={30} height={30} onClick={() => setWeekOffset(o => o - 1)}/> 
                  Vecka {currentWeekBookings.weekNumber}.
                  <Icon.ArrowRight className='right'  fill='hsl(var(--foreground))' width={30} height={30} onClick={() => setWeekOffset(o => o + 1)}/>
                   </div>
                <div style={{fontSize:18}}> Bokningar
                 – {currentWeekBookings.weekStartLabel} till {currentWeekBookings.weekEndLabel}</div>
              </CardTitle>
              <CardDescription className="admin-bookings-weeklyscheduled-card-description">
                Översikt över alla bokningar denna vecka
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="admin-bookings-weeklyscheduled-card-table-container">
                <Table>
                  <TableHeader>
                    <TableRow className="admin-bookings-weeklyscheduled-card-table-row">
                      <TableHead className="admin-bookings-weeklyscheduled-card-table-header">Datum & Tid</TableHead>
                      <TableHead className="admin-bookings-weeklyscheduled-card-table-header">Klient</TableHead>
                      <TableHead className="admin-bookings-weeklyscheduled-card-table-header">Anteckningar</TableHead>
                      <TableHead className="admin-bookings-weeklyscheduled-card-table-header">Status</TableHead>
                      <TableHead className="admin-bookings-weeklyscheduled-card-table-header">Åtgärder</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {currentWeekBookings.bookings.map((booking,index) => (
                      <TableRow key={booking.id} className="admin-bookings-weeklyscheduled-card-table-row-content">
                        
                        <TableCell>
                          <div>
                            <div className="admin-bookings-weeklyscheduled-card-table-date-cell">
                              {format(new Date(booking.slot.date.getDateOnly()), "d MMM", { locale: sv })}
                            </div>
                            <div className="admin-bookings-weeklyscheduled-card-table-date-cell-icon">
                              <AdminIcon.Clock width={20} height={20}/>
                              {booking.slot.startTime.getTime()}-{booking.slot.endTime.getTime()}
                            </div>
                            <div style={{ marginTop: 8 }}>
                              <span className="cell-pill">{getCategoryText(booking.slot.category)}</span>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div>
                            <div className="admin-bookings-weeklyscheduled-card-table-email-cell">{booking.name}</div>
                            <div className="admin-bookings-weeklyscheduled-card-table-email-cell-2">{booking.email}</div>
                          </div>
                        </TableCell>
                        <TableCell style={{color:'hsl(var(--foreground))'}}>
                          
                          {booking.notes ? <Button onClick={() => {
                            setSelectedBooking(booking);
                            handleModal('put-notes')
                            }} 
                            style={{cursor:'pointer',padding:'0.50rem 1rem',fontWeight:500,backgroundColor:'hsl(var(--muted))'}} 
                            className='warning-button' 
                            text={<><AdminIcon.EditPencil fill='hsl(var(--primary-foreground))' width={15} height={15}/> Editera anteckning</>}/>  :  <Button onClick={()=>{
                              setSelectedBooking(booking);
                              handleModal('put-notes')}} style={{cursor:'pointer',padding:'0.50rem 1rem',fontWeight:500}} className='warning-button' text={<><AdminIcon.Document fill='hsl(var(--primary-foreground))' width={15} height={15}/>Skapa anteckning</>}/>}</TableCell>
                        <TableCell>
                          {/* <Badge className={getStatusColor(booking.status)}>
                            {getStatusText(booking.status)}
                          </Badge> */}
                          <span className='cell-pill' style={getStatusColor(booking.status)}>{getStatusText(booking.status)}</span>
                        </TableCell>
                        <TableCell>
                          <div className="cell-buttons-container">
                            {/*denna action kan jag  {booking.status === BookingStatus.Pending && (
                              <button
                                onClick={() => updateBookingStatus(booking.id, BookingStatus.Confirmed)}
                                className="cell-button-one"
                              >
                                <AdminIcon.CheckCircle width={16} height={16}/>
                              </button>
                            )} */}
                            {(booking.status === BookingStatus.Confirmed || booking.status === BookingStatus.Pending) && (
                              <button
                                onClick={() => {
                                  setSelectedBooking(booking);
                                  setShowMaterialForm(true);
                                }}
                                className="cell-button-one"
                              >
                                {/* <Mail className="h-3 w-3" /> */}
                                <AdminIcon.Mail width={16} height={16}/>
                              </button>
                            )}
                            <button
                              onClick={() => {  
                                setSelectedBooking(booking);
                                handleModal('reschedule')
                              }}
                              className="cell-button-one"
                            >
                              {/* <Edit3 className="h-3 w-3" /> */}
                              <AdminIcon.EditPencil width={16} height={16}/>
                            </button>
                            {/* denna action kan jag lägga till vid begäran <button
                              onClick={() => handleModal('delete')}
                              className="cell-button-cancel"
                            >
                              <AdminIcon.Trashcan width={16} height={16}/>
                            </button> */}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </CardContent>
          </Card>
          )}
          

          {/* Hantera ledigatider */}
          <Card className="admin-surface-card card-managedates" disableHover>
            <CardHeader>
              <CardTitle className="card-managedates-title-container">
                {/* <Plus className="h-6 w-6 text-[#E16A54]" /> */}
                <AdminIcon.PlusSign fill='hsl(var(--primary))'/>
                Hantera ledigatider
              </CardTitle>
            </CardHeader>
            <CardContent>
              <label htmlFor="date" className="card-managedates-date-label">Välj datum</label>
<input
  id="date"
  type="date"
  min={new Date().toISOString().split("T")[0]}
  value={selectedDate?.toISOString().split("T")[0] || ""}
  onChange={(e) => setSelectedDate(new Date(e.target.value))}
  className="card-managedates-date-inputfield"
/>


             {selectedDate && (
  <div className="space-y-4">
    <h4 className="font-semibold text-foreground">
      Ledigatider {selectedDate.toLocaleDateString("sv-SE", { day: 'numeric', month: 'long' })}
    </h4>

    {selectedDateSlots.length > 0 ? (
      <ul className="card-managedates-createddates-stack">
        {selectedDateSlots.map((slot) => (
          <li key={slot.id} className="card-managedates-createddates-item">
            <span className="card-managedates-createddates-item-time-label">{slot.time}</span>
            <span className="cell-pill" style={{ marginLeft: 8 }}>{getCategoryText(slot.category)}</span>
            <button
              type="button"
              onClick={() =>{
                setSelectedTimeSlot(slot); 
                handleModal('remove-timeslots');
                //removeTimeSlot(slot.id)
              }}
              className="delete-timeslot-button"
            >
              <AdminIcon.Trashcan width={20} height={20}/>
            </button>
          </li>
        ))}
      </ul>
    ) : (
      <p className="card-managedates-createddates-no-timeslots">Inga ledigatider</p>
    )}

    <div className="card-managedates-add-time-stack">
      <label htmlFor="category" className="card-managedates-add-time-input-label">Kategori</label>
      <select
        id="category"
        value={selectedCategory}
        onChange={(e) => setSelectedCategory(e.target.value)}
        className="card-managedates-add-time-input"
      >
        <option value="public">Publik</option>
        <option value="rot">ROT</option>
        <option value="grow">GROW</option>
      </select>

      <label htmlFor="time" className="card-managedates-add-time-input-label">Lägg till tid</label>
      <div className="card-managedates-add-time-input-container">
        <input
          id="time"
          type="time"
          value={newTimeSlot}
          onChange={(e) => setNewTimeSlot(e.target.value)}
          className="card-managedates-add-time-input"
        />
        <button
          type="button"
          onClick={addTimeSlots}
          className="card-add-time-button"
        >
          <AdminIcon.PlusSign width={15} height={15}/>
        </button>
      </div>
    {/*Save time slots*/}
    </div>
       
    <div>
       <Button
       onClick={() => handleModal('submit-new-timeslots')} 
       style={{height:'20%',marginBottom:8,cursor:'pointer'}} 
       className='submit-button' 
       text={<><AdminIcon.Save width={16} height={16} fill='white'/> Spara tider</>}/> 
    </div>
  </div>
)}

            </CardContent>
          </Card>
        </div>

        <Card className="admin-surface-card admin-bookings-weeklyscheduled-card" disableHover>
          <CardHeader>
            <CardTitle className="admin-bookings-weeklyscheduled-card-title">
              <AdminIcon.SimpleCalendar fill='hsl(var(--primary))'/>
              Ombokningskö
            </CardTitle>
            <CardDescription className="admin-bookings-weeklyscheduled-card-description">
              Visa och hantera öppna rebook-förfrågningar och motförslag.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="admin-bookings-weeklyscheduled-card-table-container">
              <Table>
                <TableHeader>
                  <TableRow className="admin-bookings-weeklyscheduled-card-table-row">
                    <TableHead className="admin-bookings-weeklyscheduled-card-table-header">Bokning</TableHead>
                    <TableHead className="admin-bookings-weeklyscheduled-card-table-header">Status</TableHead>
                    <TableHead className="admin-bookings-weeklyscheduled-card-table-header">Föreslagna tider</TableHead>
                    <TableHead className="admin-bookings-weeklyscheduled-card-table-header">Åtgärder</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {rebookRequests.map((request) => (
                    <TableRow
                      key={request.id}
                      className="admin-bookings-weeklyscheduled-card-table-row-content"
                      style={{ opacity: isRebookRequestActive(request) ? 1 : 0.58 }}
                    >
                      <TableCell>
                        <div>
                          <div className="admin-bookings-weeklyscheduled-card-table-email-cell">
                            {request.booking?.name ?? `Bokning #${request.bookingId}`}
                          </div>
                          <div className="admin-bookings-weeklyscheduled-card-table-email-cell-2">
                            {request.booking?.email ?? ""}
                          </div>
                          <div style={{ marginTop: 8 }}>
                            <span className="cell-pill">{getCategoryText(request.booking?.slot?.category)}</span>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>
                        <span className='cell-pill' style={getRebookStatusColor(request.status)}>
                          {getRebookRequestStateText(request)}
                        </span>
                      </TableCell>
                      <TableCell>
                        <div style={{ display: 'grid', gap: 8 }}>
                          {request.proposedSlots.map((slot) => (
                            <div key={slot.id} style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                              <span>{format(new Date(slot.date), 'd MMM', { locale: sv })} {slot.startTime}</span>
                              <span className='cell-pill'>{slot.source === 'member' ? 'Motförslag' : 'Förslag'}</span>
                              {isRebookRequestActive(request) ? (
                                <button
                                  type='button'
                                  className='cell-button-one'
                                  onClick={async () => {
                                    const ok = await DataService.BookingService.AcceptRebookProposal(request.id, slot.id);
                                    if (ok) {
                                      void reloadAdminData();
                                    }
                                  }}
                                >
                                  <AdminIcon.CheckCircle width={16} height={16} />
                                </button>
                              ) : null}
                            </div>
                          ))}
                        </div>
                      </TableCell>
                      <TableCell>
                        {isRebookRequestActive(request) ? (
                          <button
                            type='button'
                          className='cell-button-cancel'
                          onClick={async () => {
                            const ok = await DataService.BookingService.DeclineRebookProposal(request.id);
                            if (ok) {
                              void reloadAdminData();
                            }
                          }}
                        >
                            <AdminIcon.Trashcan width={16} height={16} />
                          </button>
                        ) : (
                          <span className='cell-pill'>Avslutad</span>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>

        {/* Material Form Sheet */}
        {showMaterialForm && selectedBooking !== null && (
          <SendMailModal handleSendMailModalShow={(val) => setShowMaterialForm(val)} selectedBooking={selectedBooking} sendMaterial={sendMaterial}/>
        )}

        {/* Statistik */}
        <div className="adminbookings-statistics">
           <Card className="admin-surface-card adminbookings-statistics-card" disableHover>
            <CardContent className="adminbookings-statistics-card-content">
              <div className="adminbookings-statistics-card-content-container">
                <div className="adminbookings-statistics-card-content-confirmed">
                  {/* <CheckCircle className="h-6 w-6 text-white" /> */}
                  <AdminIcon.CheckCircle fill='white'/>
                </div>
                <div>
                  <div className="adminbookings-statistics-card-content-count">
                    {bookings.filter(b => b.status === BookingStatus.Confirmed).length}
                  </div>
                  <div className="adminbookings-statistics-card-status-text">Bekräftade</div>
                </div>
              </div>
            </CardContent>
          </Card>
          
           <Card className="admin-surface-card adminbookings-statistics-card" disableHover>
            <CardContent className="adminbookings-statistics-card-content">
              <div className="adminbookings-statistics-card-content-container">
                <div className="adminbookings-statistics-card-content-alert">
                  {/* <AlertCircle className="h-6 w-6 text-white" /> */}
                  <AdminIcon.Pending fill='white'/>
                </div>
                <div>
                  <div className="adminbookings-statistics-card-content-count">
                    {bookings.filter(b => b.status === BookingStatus.Pending).length}
                  </div>
                  <div className="adminbookings-statistics-card-status-text">Väntar</div>
                </div>
              </div>
            </CardContent>
          </Card>

           <Card className="admin-surface-card adminbookings-statistics-card" disableHover>
            <CardContent className="adminbookings-statistics-card-content">
              <div className="adminbookings-statistics-card-content-container">
                <div className="adminbookings-statistics-card-content-mail">
                  {/* <Mail className="h-6 w-6 text-white" /> */}
                  <AdminIcon.Mail fill='white'/>
                </div>
                <div>
                  <div className="adminbookings-statistics-card-content-count">
                    {bookings.filter(b => b.status === BookingStatus.Material_Sent).length}
                  </div>
                  <div className="adminbookings-statistics-card-status-text">Material skickat</div>
                </div>
              </div>
            </CardContent>
          </Card>

           <Card className="admin-surface-card adminbookings-statistics-card" disableHover>
            <CardContent className="adminbookings-statistics-card-content">
              <div className="adminbookings-statistics-card-content-container">
                <div className="adminbookings-statistics-card-content-rescheduled">
                  {/* <Edit3 className="h-6 w-6 text-white" /> */}
                  <AdminIcon.SimpleCalendar fill='white'/>
                </div>
                <div>
                  <div className="adminbookings-statistics-card-content-count">
                    {bookings.filter(b => b.status === BookingStatus.Rescheduled).length}
                  </div>
                  <div className="adminbookings-statistics-card-status-text">Ombokningar</div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      {showModal.delete && selectedBooking &&
        <Modal onClose={()=> handleModal('delete')}>
          <>Hej vad vill du ta bort mig för</>
          {/* <EmailFormsAdminBookings variant='cancelled' onSubmit={() => console.log('skicka mail uppdatera state osv')} booking={selectedBooking}/> */}
        </Modal> 
      }
      {showModal.reschedule && selectedBooking &&
       <RescheduleModal handleModal={handleModal} avilableSlots={timeSlots.filter(x => x.available)} selectedBooking={selectedBooking}/>
      }
      {showModal['submit-new-timeslots'] && (
        <AddTimeSlotsModal handleModal={handleModal} handleAvailabletimeSlotSubmit={handleAvailabletimeSlotSubmit} isSavingNewSlots={isSavingNewSlots} timeSlots={timeSlots} hasPendingSlots={timeSlots.some(slot => slot.newTimeSlot)}/>
      )}
      {showModal['remove-timeslots'] && typeof selectedTimeSlot !== 'undefined' && (
        <RemoveTimeSlotsConfirmationModal handleModal={handleModal} removeTimeSlot={removeTimeSlot} slotTomRemove={selectedTimeSlot} isSaving={isSavingNewSlots}/>
      )}
      {showModal['put-notes'] && selectedBooking !== null && (
                          <BookingNotesModal  handleModal={handleModal} currentNotes={selectedBooking.notes} rowId={selectedBooking.id} isSaving={isSavingNewSlots} handlePutNotes={handlePutNotes}/>
                      )}
    </div>
  );
}
